/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {SupplierBaseContract} from '../../api/contracts/supplier-base.contract';
import {StatusCellValueModel} from './status-cell-value.model';
import {FinancialNumberCellValueModel} from './financial-number-cell-value.model';
import {formatWithCurrencySymbol} from '../../shared/util/financial-number/financial-number-helper';

export function suppliersCustomersPipe(cellValue: SupplierBaseContract): string {
    let displayValue = '-';

    if (cellValue?.name != null && cellValue?.code != null) {
        displayValue = `${cellValue.code} - ${cellValue.name}`;
    }

    return displayValue;
}

export function statusPipe(cellValue: StatusCellValueModel): string {
    let displayValue = '-';

    if (cellValue?.name != null) {
        displayValue = `${cellValue.name}`;
    }

    return displayValue;
}

export function financialNumberPipe(cellValue: FinancialNumberCellValueModel): string {
    return formatWithCurrencySymbol(cellValue?.data, cellValue?.currency?.alphabeticCode);
}

export function percentPipe(cellValue: number): string {
    let displayValue = '-';

    if (cellValue != null) {
        displayValue = `${cellValue}%`;
    }
    return displayValue;
}

export function settlementComplaintCode(cellValue: string): string {
    let displayValue = '-';

    if (cellValue != null) {
        displayValue = `${cellValue}`;
    }

    return displayValue;
}
